export default __webpack_public_path__ + "static/media/close.869b314b.svg";